import React from "react";
import { HERO_STAT_ITEMS } from "./heroContent";

const HeroStatBar = () => (
  <div
    className="flex flex-wrap gap-3 md:gap-4 mt-6"
    data-testid="hero-stat-bar"
  >
    {HERO_STAT_ITEMS.map((item) => (
      <div
        key={item.label}
        className="flex flex-col items-center justify-center min-w-[4.5rem] px-3 py-2 rounded-lg border border-orange-500/25 bg-orange-500/5"
      >
        <span className="font-heading font-bold text-lg md:text-xl text-[#F3F4F6] leading-none">
          {item.value}
        </span>
        <span className="font-mono text-[10px] md:text-xs text-orange-300/80 tracking-wider mt-1">
          {item.label}
        </span>
      </div>
    ))}
  </div>
);

export default HeroStatBar;
